<template>
    <q-modal v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
        <div>
            <v-header
                    :title="$T('order') + ' ' + (form.id || '') + ' - ' + (form['order_status.description'] ?
                    $t(form['order_status.description'].toLowerCase()) : '')"
                    icon="find in page">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="close"
                              :label="$T('close')"
                              :disable="form.busy"
                              @click="close"/>
                </template>
            </v-header>
            <card width="100%">

                <form v-if="mockData && user"
                      class="row gutter-xs"
                      @keydown="form.onKeydown($event)">

                    <v-display v-model="form.created_at"
                               :label="$t('created at')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form['lending_point.description']"
                               :label="$t('lending point')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-autocomplete v-if="'Reserved' == form['order_status.description'] &&
                                          ['Courier', 'Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'].includes(user.role.name)"
                                    path="lending_kit_id"
                                    resource-path="v1/my-available-lending-kits"
                                    key="lending_kit_id"
                                    v-model="form.lending_kit_id"
                                    :label="$t('lending kit')"
                                    :item-plural="$t('lending kits')"
                                    :map="item => ({
                                        label: `${this.$T('identifier')}: ${item.identifier}`,
                                        value: item.id,
                                        sublabel: `${this.$T('codentify')}: ${item.codentify}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
                                    })"
                                    :form="form"
                                    @input="changeLendingKit($event)"
                                    class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-autocomplete>

                    <v-display v-else
                               v-model="form['lending_kit.identifier']"
                               :label="$t('lending kit')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>
                    
                    <v-display v-model="form['lending_kit_model.description']"
                            :label="$t('model')"
                            :form="form"
                            class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form['lending_kit_color.sku']"
                            :label="$t('sku code')"
                            :form="form"
                            class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form['lending_kit_color.description']"
                            :label="$t('sku description')"
                            :form="form"
                            class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-if="form['lending_kit_color.image']" class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        <img height="46" :src="`/storage/uploads/${form['lending_kit_color.image']}`">                        
                    </v-display>

                    <v-display v-model="form.firstname"
                               :label="$t('first name')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.lastname"
                               :label="$t('last name')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                  <v-display v-model="form.nif"
                             :label="$t('NIF')"
                             :form="form"
                             class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                  </v-display>

                  <v-display v-model="birthdate"
                             :label="$t('birthday')"
                             :form="form"
                             class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                  </v-display>

                    <component :is="canRegisterConsumer && !alreadySentToDCS ? 'v-input' : 'v-display'"
                               v-model="formConsumer.phone"
                               path="phone"
                               :label="$t('cell phone')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </component>

                    <component :is="canRegisterConsumer && !alreadySentToDCS ? 'v-input' : 'v-display'"
                               path="email"
                               v-model="formConsumer.email"
                               :label="$t('email')"
                               :form="formConsumer"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </component>

                    <v-display v-model="startLendingAt"
                               :label="$t('lending start date')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="endLendingAt"
                               :label="$t('lending end date')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form['origin.description']"
                               :label="$t('contact coming from')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                  <v-display path="preferred_time_to_contact"
                             v-model="form.preferred_time_to_contact"
                             :label="$t('preferred time to contact')"
                             :options="mockData.contactTime"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12"
                  > </v-display>



<!--                  <component :is="canRegisterConsumer ? 'v-input' : 'v-display'"-->
<!--                               path="referer"-->
<!--                               v-model="formConsumer.referer"-->
<!--                               :label="$t('referer code')"-->
<!--                               :form="formConsumer"-->
<!--                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">-->
<!--                    </component>-->

                    <v-display v-model="form.follow_up"
                               :label="$t('follow up')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 colx-xs-12">
                    </v-display>

                    <v-display v-model="form.observations"
                               :label="$t('observations')"
                               :form="form"
                               type="textarea"
                               :class="form.delivery != $T('yes') ? 'col-12' : 'col-md-4 col-xs-12'">
                    </v-display>

                    <v-display v-model="form.sell_order_number"
                               :label="$t('sell order number')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.full_employee_name"
                               :label="$t('employee')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12"
                               v-if="(user.role.name === 'Lending Point'
                               || user.role.name === 'Lending Point Indirect'
                               || user.role.name === 'Lending Point Hostesses')">
                    </v-display>
                    <div class="row col-12 gutter-xs" v-if="user.role.name === 'Iqos Coach'">

                        <v-display
                                v-model="form.last_contact_date"
                                :label="$t('Data último acompanhamento')"
                                :form="form"
                                path="last_contact_date"
                                class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        </v-display>

                        <v-display
                                v-model="form.contact_success_count"
                                :label="$t('Número de acompanhamentos')"
                                :form="form"
                                path="contact_success_count"
                                class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        </v-display>


                    </div>


                    <template v-if="form.delivery == $T('yes') ">

                        <v-display v-model="formatedAddress"
                                   :label="$T('delivery address')"
                                   :form="form"
                                   type="textarea"
                                   class="col-md-4 col-xs-12">
                        </v-display>

                        <v-display v-model="formatedPickupAddress"
                                   :label="$T('pickup address')"
                                   :form="form"
                                   type="textarea"
                                   class="col-md-4 col-xs-12">
                        </v-display>

                        <v-display v-model="form['channel.description']"
                                   :label="$T('channel')"
                                   :form="form"
                                   type="textarea"
                                   class="col-md-4 col-xs-12">
                        </v-display>
                    </template>
                  <br>
                  <template v-if="user.role.name === 'Iqos Coach'">
                      <v-button
                          :label="$T('Acompanhamento com sucesso')"
                          outline
                          icon="phone"
                          color="negative"
                          :loading="form.busy"
                          :form="form"
                          class="no-shadow uppercase q-btn-iqos col-xl-3 col-md-4 col-sm-6 col-xs-12 "
                          @click="incrementSuccessCount">
                      </v-button>
                      <v-button
                          :label="$T('Enviar para Remote Coach')"
                          outline
                          icon="forward"
                          color="negative"
                          :loading="form.busy"
                          :form="form"
                          class="no-shadow uppercase q-btn-iqos col-xl-3 col-md-4 col-sm-6 col-xs-12 "
                          @click="forwardToRemoteCoach"
                          v-if="canForwardToRemote">
                      </v-button>

                  </template>
                    <v-radio-buttons v-if="actions.length > 1"
                                     path="action"
                                     v-model="action"
                                     :label="$T('actions')"
                                     :options="actions"
                                     :form="form"
                                     @input="makeActionDataAdjustments"
                                     class="col-12">
                    </v-radio-buttons>

                    <template v-if="action == 1  &&  this.orderStatus !== 'Completed - Not Returned' && form.order_status_id !== 11">

                        <v-select path="no_sold_reason_id"
                                  auto-select
                                  v-model="form.no_sold_reason_id"
                                  :label="$T('no sold reason')"
                                  :item-plural="$t('no sold reasons')"
                                  :options="mockData.noSoldReasons"
                                  :form="form"
                                  dusk="no_sold_reason_id"
                                  :class="user.role.name == 'Call Center' ?  'col-xl-3 col-md-4 col-sm-6 col-xs-12' : 'col-md-6 col-xs-12'">
                        </v-select>

                        <v-input path="no_sold_reason"
                                 v-model="form.no_sold_reason"
                                 :label="$t('other reason')"
                                 optional
                                 :form="form"
                                 :class="user.role.name == 'Call Center' ?  'col-xl-3 col-md-4 col-sm-6 col-xs-12' : 'col-md-6 col-xs-12'">
                        </v-input>

                    </template>

                    <template v-if="[1, 2, 3].includes(action) &&
                                        'Call Center' == user.role.name">

                        <v-input path="pickup_address"
                                 v-model="form.pickup_address"
                                 :label="$t('pickup address')"
                                 :form="form"
                                 class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        </v-input>

                        <v-input path="pickup_address_2"
                                 v-model="form.pickup_address_2"
                                 :label="$t('pickup address 2')"
                                 :form="form"
                                 optional
                                 class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        </v-input>

                        <v-input path="pickup_zipcode"
                                 v-model="form.pickup_zipcode"
                                 :label="$t('pickup zip code')"
                                 :form="form"
                                 class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        </v-input>

                        <v-input path="pickup_city"
                                 v-model="form.pickup_city"
                                 :label="$t('pickup city')"
                                 :form="form"
                                 class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                        </v-input>

                    </template>

                    <!-- Consumer Registration -->
                    <template v-if="canRegisterConsumer">

                        <h6 class="col-12 q-mx-sm q-mb-none q-mt-lg">{{ $T('consumer registration') }}</h6>

                        <component :is="alreadySentToDCS ? 'v-display' : 'v-datetime'"
                                   path="birthdate"
                                   v-model="formConsumer.birthdate"
                                   :label="$T('birth date')"
                                   :form="formConsumer"
                                   :max="maxBirthDate"
                                   class="col-xl-3 col-md-3 col-sm-6 col-xs-12">
                        </component>

                        <component :is="'v-select'"
                                   path="gender"
                                   required
                                   v-model="formConsumer.gender"
                                   :label="$t('gender')"
                                   :item-plural="$t('origins')"
                                   :options="genderOptions"
                                   :form="formConsumer"
                                   class="col-xl-2 col-md-2 col-sm-6 col-xs-12">
                        </component>

                        <component :is="'v-input'"
                                   path="zipcode"
                                   required
                                   v-model="formConsumer.zipcode"
                                   :label="$T('zip code')"
                                   :form="formConsumer"
                                   class="col-xl-3 col-md-3 col-sm-6 col-xs-12">
                        </component>

                        <component :is="'v-input'"
                                   v-if="canRegisterDevice"
                                   path="device"
                                   v-model="formConsumer.device"
                                   :label="$T('codentify')"
                                   :form="formConsumer"
                                   class="col-xl-3 col-md-3 col-sm-6 col-xs-12">
                        </component>

                        <div v-if="canRegisterDevice" class="col-xl-1 col-md-1 col-sm-1 col-xs-1">
                            <a href="ios:webToNativeCall"><img class="codentify-camera-img"
                                                               src="https://cdn0.iconfinder.com/data/icons/shop-store-1/123/camera-01-512.png"/></a>
                        </div>

                        <component :is="'v-select'"
                                   v-if="canSelectEmployee"
                                   path="contactEmail"
                                   v-model="formConsumer.contactEmail"
                                   :label="$t('employee')"
                                   :item-plural="$t('employees')"
                                   :options="employeeOptions"
                                   :form="formConsumer"
                                   class="col-12">
                        </component>

                        <component :is="'v-input'"
                                   path="comment"
                                   v-model="formConsumer.observations"
                                   :label="$T('comments')"
                                   :form="formConsumer"
                                   type="textarea"
                                   class="col-12">
                        </component>
                    </template>

                    <v-input v-if="stockActions.length > 1 && [3].includes(action)"
                             path="device"
                             v-model="formConsumer.device"
                             :label="$T('codentify')"
                             :form="form"
                             class="col-xl-3 col-md-4 col-sm-6 col-xs-11">
                    </v-input>

                    <div v-if="stockActions.length > 1 && [3].includes(action)"
                         class="col-xl-1 col-md-1 col-sm-1 col-xs-1">
                        <a href="ios:webToNativeCall"><img class="codentify-camera-img"
                                                           src="https://cdn0.iconfinder.com/data/icons/shop-store-1/123/camera-01-512.png"/></a>
                    </div>

                    <v-select v-if="stockActions.length > 1 && [3].includes(action)"
                              path="contactEmail"
                              v-model="form.contactEmail"
                              :label="$t('employee')"
                              :item-plural="$t('employees')"
                              :options="employeeOptions"
                              :form="form"
                              class="col-12">
                    </v-select>

                    <v-input v-if="stockActions.length > 1 && [3].includes(action)"
                             path="comment"
                             v-model="form.comment"
                             :label="$T('comments')"
                             :form="form"
                             type="textarea"
                             class="col-12">
                    </v-input>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md group">

                        <!-- Call Center - Move from Reserved or In Transit to Cancelled -->
                        <v-button v-if="['Reserved', 'In Transit'].includes(form['order_status.description']) &&
                                    user.role.name == 'Call Center'"
                                  outline
                                  :label="$T('cancel order')"
                                  icon="cancel"
                                  color="negative"
                                  :loading="form.busy"
                                  class="no-shadow uppercase q-btn-iqos">
                            <q-popover>
                                <div class="group text-center">
                                    <p><strong>{{ $T('are you sure?') }}</strong></p>
                                    <v-button class="no-shadow capitalize" color="negative" no-caps
                                              @click="moveTo('cancelled')" v-close-overlay>
                                        {{ $t('yes') }}
                                    </v-button>
                                    <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                                        {{ $t('no') }}
                                    </v-button>
                                </div>
                            </q-popover>
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>

                        <!-- Call Center - Request Pickup -->
                        <v-button v-if="[1, 2, 3].includes(action) &&
                                    'Call Center' == user.role.name"
                                  outline
                                  :label="$T('request pickup')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  :loading="form.busy"
                                  @click="moveTo('pending-pick-up')">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>

                        <!-- Courier - Move from Reserved to In Transit -->
                        <v-button v-if="('Reserved' == form['order_status.description'] || 'Pending Pickup' === form['order_status.description']) &&
                                    'Courier' == user.role.name"
                                  outline
                                  :label="$T('move to in transit')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  :loading="form.busy"
                                  @click="moveTo('in-transit')">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>

                        <!-- Courier - Move from In Transit to In Lending -->
                        <!-- Lending Point - Move from Reserved to In Lending -->
                        <v-button v-if="('In Transit' == form['order_status.description'] &&
                                    'Courier' == user.role.name && form['order_operation.description'] === 'Entrega') ||
                                    ('Reserved' == form['order_status.description'] &&
                                    ('Lending Point' == user.role.name
                                    || 'Lending Point Indirect' == user.role.name
                                    || 'Lending Point Hostesses' == user.role.name
                                    || 'Iqos Coach' == user.role.name))"
                                  outline
                                  :label="$T('delivered order - move to in lending')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  :loading="form.busy"
                                  @click="moveTo('in-lending')">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>

                        <!-- Courier - Move from Pending Pickup to Completed -->
                        <!-- Lending Point - Move from In Lending to Completed -->
                        <v-button v-if="('Pending Pickup' == form['order_status.description'] &&
                                    ['Iqos Coach', 'Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'].includes(user.role.name)) ||
                                    ([1, 2, 3].includes(action) &&
                                    ( 'Completed - Not Returned' == form['order_status.description'] || 'In Lending' == form['order_status.description']) &&
                                    ('Lending Point' == user.role.name
                                    || 'Lending Point Indirect' == user.role.name
                                    || 'Lending Point Hostesses' == user.role.name
                                    || 'Iqos Coach' == user.role.name))"
                                  outline
                                  :label="$T('retrieved lending kit - move to completed')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click="moveTo('completed', stockActions.find(a => a.value == stockAction).stockStatus)"
                                  :loading="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>

                        <v-button v-if="expire && action == 0 && user.role.name !== 'Call Center'"
                                  outline
                                  :label="$T('not returned')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click="moveTo('completed', 'lost')"
                                  :loading="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>

                        <v-button v-if="'In Lending' == form['order_status.description'] &&
                                        ['Call Center'].includes(user.role.name) &&
                                        action == 0 &&
                                        canUserCompleteNotReturned"
                                  outline
                                  :label="$T('complete - not returned')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click="moveTo('completed-not-returned', 'not-returned')"
                                  :loading="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>

                        <v-button v-if="('Waiting Approval' == form['order_status.description'] && canBeCancelled) || canBeCancelForCourier"
                                  outline
                                  :label="$T('cancel')"
                                  icon="save"
                                  color="highlight"
                                  @click="moveToCancelled()"
                                  class="no-shadow uppercase q-btn-iqos">
                        </v-button>
                        <v-button v-if="'Waiting Approval' == form['order_status.description'] && canSendNewSms"
                                  outline
                                  :label="$T('Send Sms')"
                                  icon="save"
                                  color="highlight"
                                  @click="sendNewSms()"
                                  class="no-shadow uppercase q-btn-iqos">
                        </v-button>

                        <v-button v-if="('In Transit' == form['order_status.description'] && form['order_operation.description'] === 'Recolher' &&
                                    ['Courier'].includes(user.role.name))"
                                  outline
                                  :label="$T('retrieved lending kit - move to completed')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click="moveTo('completed', stockActions.find(a => a.value == stockAction).stockStatus)"
                                  :loading="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                        <v-button v-if="['Call Center'].includes(user.role.name) && action === 12"
                                  outline
                                  :label="$T('set kit lost - move to completed')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click="moveKitAndCloseOrder('lost')"
                                  :loading="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                        <v-button v-if="['Call Center'].includes(user.role.name) && action === 11"
                                  outline
                                  :label="$T('set kit broken - move to completed')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click="moveKitAndCloseOrder('broken')"
                                  :loading="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                    </div>

                </form>

                <div class="justify-center row layout-padding" v-else>
                    <spinner-iqos size="60px"/>
                </div>

            </card>
        </div>
        <div>
            <v-header
                    :title="$T('Comentários')"
                    icon="comment">

            </v-header>
            <card width="100%">

                <form v-if="mockData && user"
                      class="row gutter-xs"
                      @keydown="form.onKeydown($event)">

                    <template>
                        <div class="column-4">
                            <v-input path="comments"
                                     v-model="form.comments"
                                     :label="$T('comentário')"
                                     optional
                                     :form="form"
                                     class="col-md-6 col-xs-12">
                            </v-input>
                        </div>
                        <div>
                            <v-button
                                    :label="$T('gravar')"
                                    outline
                                    icon="save"
                                    color="negative"
                                    :loading="form.busy"
                                    :form="form"
                                    class="no-shadow uppercase q-btn-iqos "
                                    @click="saveComment">
                            </v-button>
                        </div>
                    </template>
                    <div class="px-3 py-3 w-full" style="width: 100%">
                        <!--                        <loading-view :loading="loading">-->
                        <div class="card relative">
                            <div class="overflow-hidden overflow-x-auto relative">

                                <table style="width: 100%">
                                    <thead>
                                    <tr>
                                        <th class="w-8" style="text-align: left; width: 33.33%">Comentário</th>
                                        <th class="w-8" style="text-align: left; width: 33.33%">Data e Hora</th>
                                        <th class="w-8" style="text-align: left; width: 33.33%">Criado por</th>
                                        <!--                                    <th class="text-left" v-for="(header, index) in data.headers" v-html="header" v-bind:class="[index > 2 ? 'text-center' : 'text-left']"></th>-->
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="row in rows">
                                        <td v-bind:class="[row.user_id_created === user.id ? 'w-8 black-comment' : 'w-8 green-comment']">
                                            {{row.comment}}
                                        </td>
                                        <td v-bind:class="[row.user_id_created === user.id ? 'w-8 black-comment' : 'w-8 green-comment']">
                                            {{row.created_at}}
                                        </td>
                                        <td v-bind:class="[row.user_id_created === user.id ? 'w-8 black-comment' : 'w-8 green-comment']">
                                            {{row.name}}
                                        </td>
                                    </tr>
                                    <!--                                <TableLine v-for="row in data.body" :key="row.id" :row="row.data" :metadata="row.metadata" :id="row.id"  />-->
                                    </tbody>
                                </table>

                            </div>
                        </div>
                        <!--                        </loading-view>-->
                    </div>

                </form>

                <div class="justify-center row layout-padding" v-else>
                    <spinner-iqos size="60px"/>
                </div>

            </card>
        </div>
    </q-modal>
</template>

<script>
import Form from 'vform'
import {mapGetters} from 'vuex'
import moment from 'moment'
import axios from 'axios'
import orderModel from './orderModel'
import consumerModel from './consumerModel'
import {
    QSpinnerPuff,
    QModal
} from 'quasar-framework'
import changeCase from 'change-case'
import VButton from "../components/form/VButton";
import VDisplay from "../components/form/VDisplay";
// import { Platform } from 'quasar'

export default {
    mixins: [orderModel, consumerModel],

    components: {
      VDisplay,
        VButton,
        QSpinnerPuff,
        QModal
    },

    props: {
        show: Boolean,
        item: {
            type: Object,
            default: {}
        }
    },

    data () {
        return {
            modalOrder: this.show,
            form: {},
            formConsumer: {},
            mockPath: 'v1/order-detail',
            action: 0,
            stockAction: 0,
            mockData: null,
            genderOptions: [
                {value: 3, label: this.$T("gender male")},
                {value: 4, label: this.$T("gender female")}
            ],
            employeeOptions: [{value: "", label: "-"}],
            comments: null,
            rows: [],
            expire: false,
            canBeCancelled: false,
            canSendNewSms: false,
            canForwardToRemote: false,
            canBeCancelForCourier: false,
            orderStatus: 0
        }
    },

    watch: {
        show (newVal) {
            this.modalOrder = newVal
        },

        item (newItem) {

            this.form = new Form(Object.assign(deepCopy(this.orderModel), newItem))
            this.formConsumer = new Form(Object.assign(deepCopy(this.consumerModel), {
                id: newItem.id,
                phone: newItem.phone,
                firstname: newItem.firstname,
                lastname: newItem.lastname,
                birthdate: newItem.birthdate,
                gender: newItem.gender,
                email: newItem.email,
                zipcode: newItem.zipcode,
                city: newItem.city,
                device: newItem.device,
                referer: newItem.referer,
                observations: newItem.observations,
                contactEmail: newItem.contactEmail,
                last_contact_date: newItem.last_contact_date,
                contact_success_count: newItem.contact_success_count,
                full_employee_name: newItem.full_employee_name,
                order_status_id: newItem.order_status_id
            }));
            this.getMockData();
            this.getComments()
            this.checkCanBeExpired()
            this.checkCanCancel()
            this.canForwardToRemoteCoach()
        }
    },

    methods: {

        async incrementSuccessCount () {

            let response = await this.form.post(`/api/v1/iqos-coach/incrementSuccessCount`);
            if (!response.data) return;

            this.form.contact_success_count = response.data.contact_success_count;
            this.form.last_contact_date = response.data.last_contact_date;
            this.$emit('updated')
            this.close()

        },

        async canForwardToRemoteCoach () {
            if (this.user.role.name === 'Iqos Coach') {
              let {data} = await axios.get(`/api/v1/iqos-coach/canForwardToRemoteCoach/${ this.form.id }`);
              if (data.result) {
                this.canForwardToRemote = true;
              }
            }
        },

        async forwardToRemoteCoach() {
          let {data} = await this.form.post(`/api/v1/iqos-coach/forwardToRemoteCoach`);

          if (!data) return;

          this.$q.notify(`${ data.errorMessage }`)
          if (data.result)
            this.canForwardToRemote = false;
          this.$emit('updated')
          this.close()
        },

        async saveComment () {
            let {data} = await axios.post(`/api/v1/save-comments`, {
                order_id: this.form.id,
                comment: this.form.comments
            })

            this.form.comments = '';
            this.rows = data;
            this.$emit('updated')
            this.close()
        },

        async getComments () {
            let {data} = await axios.get(`/api/v1/get-comments/${ this.form.id }`);
            this.rows = data;
        },

        async checkCanBeExpired () {
            let {data} = await axios.get(`/api/v1/call-center/expire/${ this.form.id }`);
            if (this.user.role.name === 'Call Center' && data.orderCanBeExpired && parseInt(data.days) === 30) {
                this.expire = true
            }
        },

        async checkCanCancel () {
            if (this.user.role.name === 'Call Center') {
                let {data} = await axios.get(`/api/v1/call-center/waiting-approval/${ this.form.id }`);
                this.canBeCancelled = data.orderCanBeCancelled
                this.canSendNewSms = data.canSendNewSms
            }

            if (this.user.role.name === 'Courier' ){
                let {data} = await axios.get(`/api/v1/courier/can-be-cancel/${ this.form.id }`);
                this.canBeCancelForCourier = data.orderCanBeCancelled
            }
        },

        async getEmployees () {
            let {data} = await axios.get(`${ config.appUrl }/api/v1/retail-employees`)
            this.employeeOptions.push(...data)
        },

        close () {
            this.action = 0
            this.stockAction = 0
            this.modalOrder = false
            this.$emit('close')
        },

        async getMockData () {
            this.mockData = null
            const {data} = await axios.get(`${ config.appUrl }/api/${ this.mockPath }/form-mock-data`)
            this.mockData = data.data
        },

        makeActionDataAdjustments (action) {
            if ([1, 2, 3].includes(action)) {
                this.form.pickup_address = this.form.address
                this.form.pickup_address_2 = this.form.address_2
                this.form.pickup_zipcode = this.form.zipcode
                this.form.pickup_city = this.form.city
            }

            if ([1].includes(action)) {
                this.form.is_sold = false
            }

            if ([2, 3].includes(action)) {
                this.form.is_sold = true
            }
        },

        async moveTo (orderStatus, stockStatus = '') {
            let isReserved = ('Reserved' === this.form['order_status.description'])
            let isInLending = ('In lending' === this.form['order_status.description'] || 'Completed - Not Returned' === this.form['order_status.description'])

            if (['Call Center'].includes(this.user.role.name) && isInLending) {
                this.moveOrderStatus(orderStatus, stockStatus)
            }

            if (['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses', 'Iqos Coach'].includes(this.user.role.name) && isReserved) {
                let response = await this.form.post(`/api/v1/lending-point/reservedToInLending`)
                if (!response.data) return

                let {data} = response
                if (data.reservedToInLending && data.sms) {

                    this.form.phone = data.phone;

                    this.$q.dialog({
                        title: 'Código de confirmação',
                        preventClose: true,
                        color: 'primary',
                        stackButtons: true,
                        cancel: true,
                        prompt: {
                            model: '',
                            type: 'text' // optional
                        }
                    }).then(async (token) => {

                        if (token !== '') {
                            this.form.smsCode = token;
                            this.form.phone = data.phone;

                            let response = await this.form.post(`/api/v1/lending-point/smsCodeValidation`);

                            if (response.data.result) {
                                this.moveReservedToInLending(orderStatus, stockStatus);
                            } else {
                                this.$q.notify(`${ response.data.errorMessage }`)
                            }
                        } else {
                            this.$q.notify(`Por favor insira um código válido.`)
                        }
                    }).catch(() => {
                    });
                } else {
                    this.moveReservedToInLending(orderStatus, stockStatus);
                }
            } else {
                this.moveReservedToInLending(orderStatus, stockStatus);
            }
        },

        async sendNewSms () {
            this.form.busy = true
            let {data} = await axios.post(`/api/v1/call-center/send-new-sms/${ this.form.id }`);
            if (data.result) {
                this.form.busy = false
                this.$q.dialog({
                    title: this.$T('success'),
                    message: this.$T('Sms enviado com sucesso'),
                    preventClose: true,
                    color: 'primary',
                    stackButtons: true,
                    ok: {
                        label: `${ this.$T("ok") }`
                    }
                }).then(() => {
                    this.$router.push({name: 'call-center.orders'})
                }).catch(() => {
                })
            }
        },

        async moveToCancelled () {
            this.form.busy = true
            let urlAPI = '';

            if (this.user.role.name === 'Call Center') {
                urlAPI = `/api/v1/call-center/orderCancel/${ this.form.id }`;
            }else {
                urlAPI = `/api/v1/courier/orderCancel/${ this.form.id }`;
            }

            let {data} = await axios.get(urlAPI);

            if (data.result) {
                this.form.busy = false
                this.$q.dialog({
                    title: this.$T('success'),
                    message: this.$T('Lending actualizado com sucesso'),
                    preventClose: true,
                    color: 'primary',
                    stackButtons: true,
                    ok: {
                        label: `${ this.$T("ok") }`
                    }
                }).then(() => {

                    if (this.user.role.name === 'Call Center') {
                        this.$router.push({name: 'call-center.orders'})
                    }else{
                        this.$router.push({name: 'courier.orders'})
                    }
                }).catch(() => {
                })
            }else{
                this.form.busy = false
                this.$q.notify(data.message)
            }
        },

        async moveReservedToInLending (orderStatus, stockStatus = '') {

            let greenGo = true

            //Set form to busy
            this.form.busy = true

            // Shorthand
            let role = this.user.role.name

            // Is Call Center closing order?
            let isCallCenterClosing = (orderStatus == 'pending-pick-up' &&
                role == 'Call Center')

            // Is Lending Point closing order?
            let isLendingPointClosing = (orderStatus == 'completed' &&
                (role == 'Lending Point'
                    || role == 'Lending Point Indirect'
                    || role == 'Lending Point Hostesses'))

            // Is sold?
            let isSold = this.action > 1

            // Is sold with registration?
            let isSoldWithoutRegistration = this.action == 3

            // Adjust classVenda. If is Lending Point and is sold without registration,
            // classVenda must be set to 9. 10 is default value
            if (isLendingPointClosing && isSoldWithoutRegistration)
                this.formConsumer.classVenda = 9

            // Do registration
            if (isSold && !isSoldWithoutRegistration && (isCallCenterClosing || isLendingPointClosing)) {
                this.formConsumer.isSoldWithoutRegistration = isSoldWithoutRegistration
                this.formConsumer.isCallCenterClosing = isCallCenterClosing
                this.formConsumer.isSold = isSold
                await this.formConsumer.post(`${ window.config.appUrl }/api/v1/consumer`)
                    .then(async ({data}) => {

                        while (!this.form.sell_order_number && isCallCenterClosing) {
                            await this.$q.dialog({
                                title: this.$T("success"),
                                message: data && data.success.message + (isCallCenterClosing ?
                                    ` - ${ this.$T('now enter the sell order id:') }` : ''),
                                preventClose: true,
                                prompt: isCallCenterClosing ? {
                                    model: ''
                                } : null,
                                color: "primary",
                                ok: {
                                    label: this.$T("ok")
                                }
                            }).then(orderNumber => {
                                this.form.sell_order_number = orderNumber
                            })
                        }
                    })
                    .catch(async ({response}) => {
                        greenGo = false
                        await this.$q.dialog({
                            title: this.$T("error"),
                            message: response && response.data.message,
                            preventClose: true,
                            color: "negative",
                            ok: {
                                label: this.$T("ok")
                            }
                        })
                        this.form.busy = false
                    })
            }

            if (greenGo) {
                // Get the given email and phone back to the main form
                this.form.email = this.formConsumer.email
                this.form.phone = this.formConsumer.phone
                // Now we may need other fields as well
                this.form.birthdate = this.formConsumer.birthdate
                this.form.device = this.formConsumer.device
                this.form.referer = this.formConsumer.referer
                this.form.zipcode = this.form.zipcode || this.formConsumer.zipcode
                this.form.isSoldWithoutRegistration = isSoldWithoutRegistration
                this.form.isSold = isSold
                this.form.contactEmail = this.form.contactEmail || this.formConsumer.contactEmail

                await this.form.post(
                    `${ this.baseUrl }/order/${ this.form.id }/move-to/${ orderStatus }/${ stockStatus }`)
                    .then(({data}) => {
                        this.close()
                        this.$emit('updated')
                        let msg = data.success.message

                        if (data.apiResult && data.apiResult.deviceAlreadyRegisteredOrNotValid) {
                            msg += `\nRetalho: ${ data.apiResult.message }`;
                        }

                        this.$q.dialog({
                            title: this.$T('success'),
                            message: msg,
                            preventClose: true,
                            color: 'primary',
                            stackButtons: true,
                            ok: {
                                label: this.$T('close')
                            }
                        })
                    }).catch(({response}) => {
                        let message = "";
                        if (response && response.data.hasOwnProperty('errors')) {
                            Object.values(response.data.errors).forEach((item) => {
                                message += item + ", \n"

                            })
                        } else {
                            message = "erro de comunicação. Tente novamente mais tarde"
                        }

                        this.$q.dialog({
                            title: response.data.message,
                            message: message,
                            preventClose: true,
                            color: "negative",
                            ok: {
                                label: this.$T("ok")
                            }
                        })

                        this.form.busy = false
                    })

            }

        },

        moveOrderStatus (orderStatus, stockStatus = '') {
            this.form.busy = true
            this.$q.dialog({
              title: this.$_t('this action will update the order status to :order_status',
                  {order_status: this.$t(orderStatus)}),
              preventClose: true,
              color: 'primary',
              cancel: true,
            }).onOk(() => {
              axios.post(`/api/v1/order/${ this.form.id }/move-to/${ orderStatus }/${ stockStatus }`)
            })

            this.form.busy = false
            this.$emit('close')
        },

        moveKitAndCloseOrder (stockStatus) {
            this.form.busy = true
            this.$q.dialog({
                title: this.$_t('this action will close the order and update kit to :stock_status',
                    {stock_status: this.$t(stockStatus)}),
                preventClose: true,
                color: 'primary',
                cancel: true,
            }).then(async () => {
                axios.post('/api/v1/move-kit-close-order', {
                    order_id: this.form.id,
                    stock_status: stockStatus
                })
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            this.$q.notify({
                                color: 'positive',
                                icon: 'thumb_up',
                                message: response.data.success.message
                            })
                        }
                    })
            }).catch(() => {

            })
            this.form.busy = false
            this.$emit('close')
        },

      async changeLendingKit(event) {

        if (event) {
          let {data} = await axios.get(`/api/v1/lending-kit-with-sku/${ event }`);
          if (typeof data.lending_kit_color !== 'undefined') {
            this.form = new Form(Object.assign(this.form, {
              'lending_kit_model.description': data.lending_kit_color.lending_kit_model.description,
              'lending_kit_color.sku': data.lending_kit_color.sku,
              'lending_kit_color.description': data.lending_kit_color.description,
              'lending_kit_color.image': data.lending_kit_color.image
            }));
          }
        } else {
          this.form = new Form(Object.assign(this.form, {
            'lending_kit_model.description': null,
            'lending_kit_color.sku': null,
            'lending_kit_color.description': null,
            'lending_kit_color.image': null
          }));
        }

      }

    },

    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),

        baseUrl () {
            return `${ window.config.appUrl }/api/v1/${ changeCase.paramCase(this.user.role.name) }`
        },

        startLendingAt () {
            if (!this.form.start_lending_at)
                return this.$T('not started yet')
            return moment(this.form.start_lending_at).format('DD-MM-YYYY')
        },

        birthdate () {
            if (!this.form.birthdate)
              return this.$T('not started yet')
            return moment(this.form.birthdate).format('DD-MM-YYYY')
        },

        endLendingAt () {
            if (!this.form.end_lending_at && !this.form.start_lending_at)
                return this.$_T(':days days after start', {days: this.mockData.lendingDays})
            else if (this.form.start_lending_at && !this.form.end_lending_at)
                return moment(this.form.start_lending_at).add(this.mockData.lendingDays, 'days')
                    .format('DD-MM-YYYY') + ' - ' + this.$T('planned')
            return moment(this.form.end_lending_at).format('DD-MM-YYYY')
        },

        formatedAddress () {
            if (this.form.address)
                return this.form.address + ', ' +
                    (this.form.address_2 ? this.form.address_2 + ', ' : '') +
                    this.form.city + '. ' +
                    this.$T('zip code') + ': ' + this.form.zipcode
            return ''
        },

        formatedPickupAddress () {
            if (this.form.pickup_address)
                return this.form.pickup_address + ', ' +
                    (this.form.pickup_address_2 ? this.form.pickup_address_2 + ', ' : '') +
                    this.form.pickup_city + '. ' +
                    this.$T('zip code') + ': ' + this.form.pickup_zipcode
            return ''
        },

        actions () {
            let order = this.item
            let role = this.user.role.name
            let orderStatus = this.form['order_status.description']
            let lendingPointType = this.form['lending_point.lending_point_type_id']
            this.orderStatus = this.form['order_status.description']

            let actions = [{value: 0, label: this.$T('no action')}]

            // Call Center
           if (order.delivery == this.$T('yes') && role == 'Call Center' && orderStatus == 'In Lending')
                actions = actions.concat([
                    {value: 1, label: `${ this.$T('pick up') } <strong>&gt; ${ this.$T('no sold') }</strong>`},
                    {value: 2, label: `${ this.$T('pick up') } <strong>&gt; ${ this.$T('sold') }</strong>`}
                ])

            // Call Center
           /* if ((lendingPointType === 1 || lendingPointType === 4) && role == 'Call Center') {
                actions = actions.concat([
                    {
                        value: 11,
                        stockStatus: 'broken',
                        label: `${ this.$T('lending kit') } <strong>&gt; ${ this.$T('broken') }</strong>`
                    },
                    {
                        value: 12,
                        stockStatus: 'lost',
                        label: `${ this.$T('lending kit') } <strong>&gt; ${ this.$T('lost') }</strong>`
                    }
                ])
            }
            */
            // Lending Point
            if ((role == 'Lending Point'
                || role == 'Lending Point Indirect'
                || role == 'Lending Point Hostesses')
                && (orderStatus == 'In Lending' || orderStatus == 'Completed - Not Returned'))

                if (this.form['lending_point.heet_seller']) {
                    actions = actions.concat([
                        {value: 1, label: `${ this.$T('collect') } <strong>&gt; ${ this.$T('no sold') }</strong>`}
                    ])
                } else {
                    actions = actions.concat([
                        {value: 1, label: `${ this.$T('collect') } <strong>&gt; ${ this.$T('no sold') }</strong>`},
                        {
                            value: 3,
                            label: `${ this.$T('buy other model') } <strong>&gt; ${ this.$T(
                                'sold, no registration') }</strong>`
                        },
                        {
                            value: 2,
                            label: `${ this.$T('buy other model') } <strong>&gt; ${ this.$T(
                                'sold, registration') }</strong>`
                        }
                    ])
                }

            if (role == 'Iqos Coach' && orderStatus == 'In Lending') {
                actions = actions.concat([
                    {value: 1, label: `${ this.$T('collect') } <strong>&gt; ${ this.$T('close lending') }</strong>`}
                    /*{
                     value: 2,
                     label: `${this.$T('buy other model')} <strong>&gt; ${this.$T('sold, registration')}</strong>`
                     }*/
                ])
            }

            return actions
        },

        stockActions () {
            let role = this.user.role.name
            let orderStatus = this.form['order_status.description']

            let actions = [{value: 0, label: this.$T('no action')}]

            if ((orderStatus == 'Pending Pickup' && role == 'Courier') ||
                ((orderStatus == 'In Lending' || orderStatus == 'Completed - Not Returned') && (role == 'Lending Point' || role == 'Lending Point Indirect' || role == 'Lending Point Hostesses')))
                actions = [
                    {
                        value: 0,
                        stockStatus: 'to-clean',
                        label: `${ this.$T('lending kit') } <strong>&gt; ${ this.$T('to clean/charge') }</strong>`
                    },
                    {
                        value: 11,
                        stockStatus: 'broken',
                        label: `${ this.$T('lending kit') } <strong>&gt; ${ this.$T('broken') }</strong>`
                    },
                    {
                        value: 12,
                        stockStatus: 'lost',
                        label: `${ this.$T('lending kit') } <strong>&gt; ${ this.$T('lost') }</strong>`
                    },
                    {
                        value: 13,
                        stockStatus: 'not-returned',
                        label: `${ this.$T('lending kit') } <strong>&gt; ${ this.$T('not returned') }</strong>`
                    }
                ]

            return actions
        },

        canRegisterConsumer () {
            return ['Call Center', 'Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses', 'Iqos Coach'].includes(this.user.role.name)
        },

        canRegisterDevice () {
            return this.action == 2 && ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses', 'Iqos Coach'].includes(this.user.role.name)
        },

        alreadySentToDCS () {
            return !!this.form.iqos_user_id
        },

        canSelectEmployee () {
            return this.action == 2 && ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'].includes(this.user.role.name)
        },

        maxBirthDate () {
            return moment().subtract(18, 'years').format('YYYY-MM-DD\THH:mm:ss.SSSZ')
        },

        canUserCompleteNotReturned () {
            //@waiting for client (PMI) instructions for conditions to enable the action
            return false
        }
    },
    mounted () {
        this.getEmployees();
    },

    created: function () {

        window.addEventListener('updateDeviceEvent', (data) => {
            this.formConsumer.device = data.detail.value;
        })
    },

    destroyed: function () {
        window.removeEventListener('updateDeviceEvent', () => {
        })
    }
}
</script>

<style>
    .codentify-camera-img {
        width: 4em;
        display: block;
        margin-top: 0.5em;
    }

    .column-4 {
        float: left;
        width: 90%;
        padding: 10px;
    }

    .green-comment {
        color: #229954 !important;
    }

    .black-comment {
        color: black !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/_orderDetail.vue